(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5126],{

/***/ 5393:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tours",
      function () {
        return __webpack_require__(91800);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27051);

var useAppDispatch = function() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
};
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;


/***/ }),

/***/ 3106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ PrintConfigContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


var PrintConfigContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isPrint: false,
    images: {
        lazyloadEnabled: true
    }
});
var PrintConfigProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrintConfigContext.Provider, {
        value: {
            isPrint: true,
            images: {
                lazyloadEnabled: false
            }
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PrintConfigProvider);


/***/ }),

/***/ 42500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CloudinaryImage_CloudinaryImage; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(88149);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/CloudinaryImage.module.scss
var CloudinaryImage_module = __webpack_require__(47464);
var CloudinaryImage_module_default = /*#__PURE__*/__webpack_require__.n(CloudinaryImage_module);
// EXTERNAL MODULE: ./src/integrations/cloudinary/cloudinaryUrlGenerator.ts
var cloudinaryUrlGenerator = __webpack_require__(49077);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+react@1.5.0_@cloudinary+url-gen@1.8.6_@types+react@18.0.20_react@18.2.0/node_modules/@cloudinary/react/index.js
var react = __webpack_require__(90330);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+transformation-builder-sdk@1.21.2/node_modules/@cloudinary/transformation-builder-sdk/actions/resize.js + 38 modules
var resize = __webpack_require__(66469);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+url-gen@1.8.6/node_modules/@cloudinary/url-gen/assets/CloudinaryVideo.js + 1 modules
var CloudinaryVideo = __webpack_require__(54074);
// EXTERNAL MODULE: ../../node_modules/.pnpm/use-device-pixel-ratio@1.1.2_react@18.2.0/node_modules/use-device-pixel-ratio/dist/index.module.js
var index_module = __webpack_require__(16867);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+transformation-builder-sdk@1.21.2/node_modules/@cloudinary/transformation-builder-sdk/actions/delivery.js + 5 modules
var delivery = __webpack_require__(94134);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var node_modules_react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/app/providers/PrintConfigProvider.tsx
var PrintConfigProvider = __webpack_require__(3106);
;// CONCATENATED MODULE: ./src/components/elements/media/CloudinaryImage/CloudinaryImage.tsx












var CloudinaryImage = function(param) {
    var image = param.image, tmp = param.lazyload, lazyloadOption = tmp === void 0 ? true : tmp, tmp1 = param.responsive, responsiveOption = tmp1 === void 0 ? true : tmp1, tmp2 = param.placeholder, placeholderOption = tmp2 === void 0 ? false : tmp2, width = param.width, height = param.height, _sizeAttributes = param.sizeAttributes, sizeAttributes = _sizeAttributes === void 0 ? false : _sizeAttributes, tmp3 = param.dpr, dprOption = tmp3 === void 0 ? true : tmp3, _cropType = param.cropType, cropType = _cropType === void 0 ? "fill" : _cropType, aspectRatio = param.aspectRatio, titleDefault = param.titleDefault, altDefault = param.altDefault, _className = param.className, className = _className === void 0 ? "" : _className, style = param.style, _placeholderClassName = param.placeholderClassName, placeholderClassName = _placeholderClassName === void 0 ? "" : _placeholderClassName, cld = param.cld, trackingStringClick = param.trackingStringClick, trackingStringDblClick = param.trackingStringDblClick;
    var deviceDpr = (0,index_module/* useDevicePixelRatio */.j)();
    var printConfig = (0,node_modules_react.useContext)(PrintConfigProvider/* PrintConfigContext */.E);
    lazyloadOption = printConfig.images.lazyloadEnabled === false ? false : lazyloadOption;
    if (!(image === null || image === void 0 ? void 0 : image.publicId)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((CloudinaryImage_module_default()).placeholder, " ").concat(placeholderClassName)
        });
    }
    if (!cld) {
        cld = cloudinaryUrlGenerator/* default */.Z;
    }
    var mediaFile = image.resourceType === "video" ? cld.video(image.publicId) : cld.image(image.publicId);
    var options = {};
    if (aspectRatio) {
        options.aspect_ratio = aspectRatio;
    }
    if (image.resourceType !== "video") {
        mediaFile.format("auto").quality("auto");
    } else {
        mediaFile.format("auto").quality(70);
    }
    if (dprOption && image.resourceType !== "video") {
        var imageDpr = Number.isInteger(dprOption) ? dprOption : deviceDpr;
        mediaFile.delivery((0,delivery/* dpr */.uN)(imageDpr + ".0"));
    } else {
    // omit dpr for videos
    //mediaFile.delivery(dpr('1.0'))
    }
    var cropSettings;
    switch(cropType){
        case "fill":
            cropSettings = (0,resize/* fill */.hl)();
            break;
        case "scale":
            cropSettings = (0,resize/* scale */.bA)();
            break;
    }
    if (!responsiveOption) {
        if (width) {
            cropSettings.width(width);
        }
        if (height) {
            cropSettings.height(height);
        }
    }
    if (aspectRatio) {
        cropSettings.aspectRatio(aspectRatio);
    }
    if (cropType === "fill" && (aspectRatio || width || height)) {
        if ((0,_instanceof/* default */.Z)(mediaFile, CloudinaryVideo/* CloudinaryVideo */._)) {
            // Videos cannot handle gravity('auto') on mobile
            // @ts-ignore
            cropSettings.gravity("center");
        } else {
            // @ts-ignore
            cropSettings.gravity("auto");
        }
    }
    mediaFile.resize(cropSettings);
    // see: https://cloudinary.com/documentation/react_image_transformations#plugins
    var plugins = [];
    // placeholder
    // Note: Not using recommended plugin order, as this loads the display image before placeholder image | see: https://cloudinary.com/documentation/react_image_transformations#plugin_order
    if (placeholderOption || lazyloadOption === "placeholder") {
        plugins.push((0,react/* placeholder */.W$)({
            mode: "blur"
        })) // see: https://cloudinary.com/documentation/react_image_transformations#image_placeholders
        ;
    }
    // lazyload
    if (lazyloadOption) {
        plugins.push((0,react/* lazyload */.mA)());
    }
    // responsive breakpoints
    if (responsiveOption) {
        plugins.push((0,react/* responsive */.jW)({
            steps: 200
        }));
    }
    var getSizeAttributes = function() {
        if (sizeAttributes) {
            // custom sizes
            if (width && height) {
                return {
                    width: width,
                    height: height
                };
            }
            // dynamic sizes by aspect ratio
            if (aspectRatio) {
                if (width) {
                    return {
                        width: width,
                        height: width / aspectRatio
                    };
                }
                if (height) {
                    return {
                        width: height * aspectRatio,
                        height: height
                    };
                }
            }
            // intrinsic sizes
            return {
                width: image.width,
                height: image.height
            };
        }
        return {};
    };
    var getTrackingAttributes = function() {
        var trackingAttributes = {};
        // if "trackingStringClick" is set, build "data-tr-click={trackingStringClick}"
        if (trackingStringClick) {
            trackingAttributes["data-tr-click"] = trackingStringClick;
        }
        // if "trackingStringDblClick" is set, build "data-tr-click={trackingStringDblClick}"
        if (trackingStringDblClick) {
            trackingAttributes["data-tr-dblclick"] = trackingStringDblClick;
        }
        return trackingAttributes;
    };
    return function() {
        if ((0,_instanceof/* default */.Z)(mediaFile, CloudinaryVideo/* CloudinaryVideo */._)) {
            var posterImage = mediaFile.addTransformation("so_0").toURL();
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react/* AdvancedVideo */.xl, {
                cldVid: mediaFile,
                poster: posterImage,
                plugins: plugins,
                autoPlay: true,
                playsInline: true,
                loop: true,
                muted: true
            });
        }
        var _title, ref, _description, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react/* AdvancedImage */.pw, (0,_object_spread/* default */.Z)({
            className: className,
            cldImg: mediaFile,
            plugins: plugins,
            title: (ref = (_title = image.title) !== null && _title !== void 0 ? _title : titleDefault) !== null && ref !== void 0 ? ref : "",
            alt: (ref1 = (_description = image.description) !== null && _description !== void 0 ? _description : altDefault) !== null && ref1 !== void 0 ? ref1 : "",
            loading: lazyloadOption === true ? "lazy" : "auto",
            style: style !== null && style !== void 0 ? style : {}
        }, getSizeAttributes(), getTrackingAttributes()));
    }();
};
/* harmony default export */ var CloudinaryImage_CloudinaryImage = (CloudinaryImage);

;// CONCATENATED MODULE: ./src/components/elements/media/CloudinaryImage/index.ts



/***/ }),

/***/ 49077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73974);

var cloudinaryUrlGenerator = new _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_0__/* .Cloudinary */ .r({
    cloud: {
        cloudName: "skag"
    },
    url: {
        analytics: false
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (cloudinaryUrlGenerator);


/***/ }),

/***/ 91800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ tours; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/pages/TravelFilterPage/FilterPage.module.scss
var FilterPage_module = __webpack_require__(36972);
var FilterPage_module_default = /*#__PURE__*/__webpack_require__.n(FilterPage_module);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterNav/TravelFilterNav.module.scss
var TravelFilterNav_module = __webpack_require__(28201);
var TravelFilterNav_module_default = /*#__PURE__*/__webpack_require__.n(TravelFilterNav_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(32758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterForm/index.ts + 3 modules
var TravelFilterForm = __webpack_require__(66795);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.1_@babel+core@7.29.7_@types+react-dom@18.0.6_@types+react@18.0.20_babel-plugi_4de291d6de77943be594741332b7d5bc/node_modules/next/router.js
var next_router = __webpack_require__(24826);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterInfoAndReset/index.ts + 1 modules
var TravelFilterInfoAndReset = __webpack_require__(19562);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterNav/TravelFilterNav.tsx








var TravelFilterNav = function() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var router = (0,next_router.useRouter)();
    var setUrlQueryString = function(queryString) {
        var checkString = "".concat(router.pathname).concat(queryString ? "?" + queryString : "");
        if (router.asPath !== checkString) {
            router.push({
                pathname: router.pathname,
                query: queryString
            }, undefined, {
                shallow: true
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        id: "travel-filter-nav",
        className: (TravelFilterNav_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    lg: "3",
                    className: "".concat((TravelFilterNav_module_default()).title),
                    children: [
                        t("travelFilter.findTravel"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: "6",
                    className: (TravelFilterNav_module_default()).inputs,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelFilterForm/* default */.Z, {
                        setUrlQueryString: setUrlQueryString
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: "3",
                    className: (TravelFilterNav_module_default()).info,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        className: "align-self-end mt-2 mt-lg-0 ".concat((TravelFilterNav_module_default()).resultInfoWrap),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelFilterInfoAndReset/* default */.Z, {})
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var TravelFilterNav_TravelFilterNav = (TravelFilterNav);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterNav/index.tsx


// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterResultList/index.tsx + 186 modules
var TravelFilterResultList = __webpack_require__(73218);
;// CONCATENATED MODULE: ./src/components/pages/TravelFilterPage/TravelFilterPage.tsx





var TravelFilterPage = function(param) {
    var initialTravels = param.initialTravels;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                fluid: true,
                className: "".concat((FilterPage_module_default()).root, " py-3 shadow-lg"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelFilterNav_TravelFilterNav, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelFilterResultList/* default */.Z, {
                travels: initialTravels,
                className: "mt-5 mb-4",
                trackingStringPrefix: "travel_filter:filter"
            })
        ]
    });
};
/* harmony default export */ var TravelFilterPage_TravelFilterPage = (TravelFilterPage);

;// CONCATENATED MODULE: ./src/components/pages/TravelFilterPage/index.tsx


// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(70224);
// EXTERNAL MODULE: ./src/features/travelFilter/index.ts + 1 modules
var travelFilter = __webpack_require__(38411);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.1_@babel+core@7.29.7_@types+react-dom@18.0.6_@types+react@18.0.20_babel-plugi_4de291d6de77943be594741332b7d5bc/node_modules/next/head.js
var head = __webpack_require__(57966);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/tours.tsx








var TravelFilter = function(param) {
    var filterResponse = param.filterResponse;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        // set initial data
        dispatch((0,travelFilter/* setInitialTravelFilterResponse */.Qw)({
            filterResponse: filterResponse
        }));
        // load from URL query string
        setTimeout(function() {
            dispatch((0,travelFilter/* applyTravelFilterUrlQuery */.JS)({
                filterResponse: filterResponse,
                router: router
            }));
        }, 20);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("pages.travelFilter.seo.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("pages.travelFilter.seo.description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: t("pages.travelFilter.seo.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: t("pages.travelFilter.seo.description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: t("pages.travelFilter.seo.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: t("pages.travelFilter.seo.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelFilterPage_TravelFilterPage, {
                initialTravels: filterResponse.travels
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var tours = (TravelFilter);


/***/ }),

/***/ 47464:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"CloudinaryImage_placeholder__kWdxK"};

/***/ }),

/***/ 28201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelFilterNav_root__443T7","title":"TravelFilterNav_title__TbHer","inputs":"TravelFilterNav_inputs__Wo1nU","info":"TravelFilterNav_info__HcdVG","resultInfo":"TravelFilterNav_resultInfo__h1KmG","submitWrap":"TravelFilterNav_submitWrap__3t8OZ","resultInfoWrap":"TravelFilterNav_resultInfoWrap__4yRm2","submitBtn":"TravelFilterNav_submitBtn__RgIEe"};

/***/ }),

/***/ 36972:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterPage_root__njzWz"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6526,4127,7175,4358,6018,5467,7536,9774,2888,179], function() { return __webpack_exec__(5393); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);